<template>
  <div class="localidades container">
    <custom-select
      label="Localidad"
      :value="value"
      :name="name"
      @input="onChange"
      :items="_localidades"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import CustomSelect from "@/components/core/custom/CustomSelect";
import { mapState } from "vuex";

export default {
  name: "CityList",
  components: { CustomSelect },
  props: {
    value: String,
    name: String,
    codProv: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localidades: []
    };
  },
  computed: {
    ...mapState({
      localidadesAgregadas: state => {
        return state.localidadesAgregadas;
      }
    }),
    _localidades() {
      const agregadas = this.localidadesAgregadas[this.codProv] || [];
      // Sumar a las localidades la localidad
      // agregada que puede haber venido de la
      // validación. Filtramos las duplicadas
      return [...agregadas, ...this.localidades].filter(
        (item, index, self) =>
          index === self.findIndex(t => t.value === item.value)
      );
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    },
    async getLocalidades(province) {
      try {
        const response = await fetch(`localidades/${province}.json`);
        const localidades = await response.json();

        if (localidades) {
          this.localidades = localidades.localidades.map(localidad => {
            return {
              value: localidad.toUpperCase(),
              label: localidad.toUpperCase()
            };
          });
        }
      } catch (error) {
        console.error("Error fetching localidades:", error);
      }
    }
  },
  mounted() {
    this.getLocalidades(this.codProv);
  },
  watch: {
    codProv: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getLocalidades(newVal);
      }
    },
    value: function(newVal) {
      this.localidadesAgregadas[this.codProv].push({
        value: newVal.toUpperCase(),
        label: newVal.toUpperCase()
      });
      this.getLocalidades(newVal);
    }
  }
};
</script>
<style scoped>
.localidades {
  margin-top: 16px;
}
</style>
